var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function ConsumerExternalProfileWS() {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  //
  // AKA call the super class' -- AbstractWS -- constructor.
  AbstractWS.apply(this, arguments);

  self = this;
  self.name = "ConsumerExternalProfileWS"; // Convenience name for debugging

  self.queueId = undefined;
  self.merchantConsumerInfoId = undefined;
  self.url = "";

  self.openWindow = function (url) {
    var options = 'resizable=1,menubar=1,scrollbars=1,status=1,titlebar=1,toolbar=1,width=800,height=600,left=200,top=200,screenX=0,screenY=0';
    var win = window.open(url, null, options);

    if (win) {
      win.focus();
    } else {
      console.log('Could not popup new window for URL: ', url);
    }
  }

  self.openProfile = function(queueId, merchantConsumerInfoId) {
    self.reset();
    self.queueId = queueId;
    self.merchantConsumerInfoId = merchantConsumerInfoId;
    self.doRequest();
  }

  /**
   * Defines the string to request API services
   *
   * @method serviceURL
   * @returns {String}
   */
  self.serviceURL = function() {
    var url =
      "/qless/api/v1/employee/queue/" +
      self.queueId +
      "/consumerExternalProfile/" +
      self.merchantConsumerInfoId;

    return url
  };

  /**
   * Extracts the URL from the XML response then opens a new Window.
   *
   * @method processData
   * @param {XMLString} xmlData
   * @returns {ConsumerSearchWS}
   */
  self.processData = function(data) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, data);

    var json = xmlToJson.parse(data);
    if (json && json.url) {
      self.url = json.url.value;
    }

    if (self.isValidUrl(self.url)) {
      // `processData` opens the Window because calling AbstractWS.processData
      // clears the callback in `self.callback` and this happens before we
      // parse the JSON.
      self.openWindow(self.url)
    }

    return self;
  };

  self.isValidUrl = function(url) {
    var uriProtocolRegex = new RegExp("^http[s]?://")
    var valid = uriProtocolRegex.test(url)
    return (url && valid)
  }

  self.reset = function () {
    AbstractWS.prototype.reset.call(self);
    self.queueId = undefined;
    self.merchantConsumerInfoId = undefined;
    self.url = "";
  }

  return self;
}

// "Inherit" from AbstractWS
ConsumerExternalProfileWS.prototype = AbstractWS.prototype;

module.exports = ConsumerExternalProfileWS
